import { render } from "./TermEditTable.vue?vue&type=template&id=0cee06c8&scoped=true&ts=true"
import script from "./TermEditTable.vue?vue&type=script&lang=ts"
export * from "./TermEditTable.vue?vue&type=script&lang=ts"

import "./TermEditTable.vue?vue&type=style&index=0&id=0cee06c8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cee06c8"]])

export default __exports__